import { IDomainState } from "models/domainStates";

export const selectPasteSiteItem = (state: IDomainState) => state.pasteModal;
